/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ThreatRatingDisplayEnum } from './threatRatingDisplayEnum';


/**
 * Calculated stress threat rating
 */
import { ValidateUtils } from 'app/shared/utils';

export class StressRating { 
    stressThreatRating?: ThreatRatingDisplayEnum | null;

    constructor(item?: Partial<StressRating>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            stressThreatRating: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.stressThreatRating : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: StressRating.isValid,
        };
    }

    static isValid(obj: StressRating): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = StressRating.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.stressThreatRating.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

